import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { HomeService } from '../_services/home.service';
import { AuthenticationService } from '../_services/index';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
@Component({
selector: 'app-search-articles',
templateUrl: './search-articles.component.html',
styleUrls: ['./search-articles.component.scss']
})
export class SearchArticlesComponent implements OnInit {
pk: any;
i18n: any;
topics: any;
names: any;
status: any;
helpTopics: any;
article: any;
name: any;
parentPk: any;
id: any;
parent: any;
topArticles: any;
searchdata: any[];
selectedValue: any;
keyword = 'name';
data = [];
caseAlertMessage: string;
alert: boolean = false;
delayed: boolean = false;
topicName: any;
chaildTopics: any;
searchBanner: any;
searchTextboxNote: any;
searchTextboxHover: any;
searchButtonHover: any;
searchKey: any;

constructor(private homeService: HomeService,private authenticationService: AuthenticationService, private router: Router, private activatedRoute: ActivatedRoute,private route: ActivatedRoute,private gaService : GoogleAnalyticsService) {
  this.activatedRoute.queryParams.subscribe(params => {
    this.pk = params['pk'];
    this.getAllArticle();
    this.i18n = homeService.session.get('i18n');
    this.parentPk = params['parentPk'];
  });
}
ngOnInit() {
  this.gaService.updatePageName();
  this.kbSearchConfig();
  this.getHelpTopics();
  this.getTopArticles();
  this.getArticle();
  this.getChildren();
  this.getAllChildArticle();
}


kbSearchConfig(){
  this.homeService.getKbSearchConfiguration().subscribe(res => {
    this.searchBanner = res.return_body.searchBanner;
    this.searchTextboxNote = res.return_body.searchTextboxNote;
    this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
    this.searchButtonHover = res.return_body.searchButtonHoverNote;
  });
}

getAllArticle() {
    this.homeService.getChildren(this.parentPk).subscribe(res => {
      this.topics = res;
      this.names= res.return_body;
    });
  }
  getAllChildArticle() {
    debugger
    this.homeService.getChildren(this.pk).subscribe(res => {
      this.chaildTopics = res;
      this.names= res.return_body;
    });
  }
  getArticle() {
    debugger
    this.homeService.getChildren(this.parentPk).subscribe(res => {
      this.names= res.return_body;
      for(var val of this.names){
        if(val.pk==this.pk){
          this.topicName=val.stepName
        }
      }
    });
  }
  getTopArticles() {    
    this.homeService.getTopArticles().subscribe(res => {
    this.topArticles = res.return_body;
  });
}
getChildren() {
  debugger
  this.homeService.getChildren(this.parentPk).subscribe(res => {
  this.topics = res;
  this.names= res.return_body;
  this.getHelpTopics();
  for(var val of this.names){
    this.name= val.stepName
    this.status=val.kbData
  }
  });
  }
  getHelpTopics() {
    
    this.homeService.getHelpTopics().subscribe(res => {
    this.names= res.return_body;
    this.helpTopics = res;
    this.names=res.return_body
      for(var val of this.names){
        if(val.pk==this.parentPk){
          this.status=val.pk
          this.parent= val.stepName
        }
      }
    });
  }
handleNavigation(pk,parentPk,serachPk) {
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/helptopics'], { queryParams: { PK: pk,childPk:parentPk }}); 
  
}
viewArticle(id,articleTag) { 
  this.router.navigate(['/' + this.router.url.split('/')[1] + '/article'], { queryParams: { articleId: id ,Pk:this.pk,childPk:this.parentPk,articleTag:articleTag} });
}

getCurrentPage(pathValue) {
  if (pathValue) {
    this.router.navigate([this.router.url.split("/")[1], pathValue]);
  }
}
  navigate(pk,parentPk,searchPk) {
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/kb'], { queryParams: { PK: pk,childPk:parentPk,searchPk:searchPk }});
  }
  selectEvent(item) {
    this.selectedValue = item.name;
    this.search(this.selectedValue);
  }

  onChangeSearch(val: string) {
    this.selectedValue = val;
    this.data = [];
    if (val != '') {
      this.homeService.getSearchData(val).subscribe(res => {
        this.data = [];
        res.return_body.map((response, index) => {
          this.data.push({ id: index, name: response });
        })
      });
    }
  }

  onFocused(e) {
    this.data = [];
  }

  search(selectedValue){
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: selectedValue, currentPage: 0 }});
  }
  onKeyEnterSearch(event: any, searchkeyWrd: any) {
    this.search(searchkeyWrd);
  }

  searchCleared(){
    this.selectedValue = '';
  }

  ngAfterViewInit() {
    this.caseMessage();
  }
  
   caseMessage() {
    this.caseAlertMessage = sessionStorage.getItem('alertMessage')
    if (this.caseAlertMessage) {
      this.alert = true
    }
    setInterval(() => {
      this.delayed = true
      this.alert = false
      sessionStorage.removeItem('alertMessage')
    }, 5000);
  }  

}
